/** PosProvider z BE: system kasowy lokalu. Brak POS-a = null (w formularzu pusty string). */
export enum PosProvider {
  DOTYKACKA = 'DOTYKACKA',
}

export const POS_PROVIDERS: PosProvider[] = Object.values(PosProvider);

/** Wartosc z formularza do requestu: pusty wybor = null (lokal bez POS-a). */
export const toPosProviderPayload = (value: string | null | undefined): PosProvider | null =>
  POS_PROVIDERS.includes(value as PosProvider) ? (value as PosProvider) : null;

/** Sekcja Dotykacki tylko dla lokalu, ktoremu admin zapisal POS Dotykacka. */
export const usesDotykacka = (posProvider: string | null | undefined): boolean =>
  posProvider === PosProvider.DOTYKACKA;
